import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { PasMomentService } from '@porsche-aftersales/frontend-toolbox';

import { UserService } from '../../services/user-service/user.service';

@Injectable({ providedIn: 'root' })
export class DynamicLocaleService {
  private readonly userService = inject(UserService);
  private readonly pasMomentService = inject(PasMomentService);

  private readonly i18nPipes: any;
  private userLanguage: string;

  public constructor() {
    const currencyPipe = inject(CurrencyPipe);
    const datePipe = inject(DatePipe);
    const decimalPipe = inject(DecimalPipe);
    const percentPipe = inject(PercentPipe);

    this.i18nPipes = [currencyPipe, datePipe, decimalPipe, percentPipe];
  }

  /*
   * Sets user locale for pipes.
   * Without this, calling pipes in code will not return localized result.
   */
  /* eslint-disable no-prototype-builtins */
  public setLocale(): void {
    this.userLanguage = this.userService.userLanguage;
    // Set moment locale to 'de' for German date formatting (independent of UI text language)
    this.pasMomentService.setLocale('de');
    this.i18nPipes.forEach((pipe: any) => {
      if (pipe.hasOwnProperty('locale')) {
        pipe.locale = this.userLanguage;
      } else if (pipe.hasOwnProperty('_locale')) {
        pipe._locale = this.userLanguage;
      }
    });
  }
  /* eslint-enable no-prototype-builtins */
}
